import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'intro',
      component: () => import('./views/Opening.vue'),
    },
    // {
    //   path: '/quiz/teams',
    //   name: 'teams-questions',
    //   component: () => import('./views/Teams.vue'),
    //   meta: { ind: 1 },
    // },
    // {
    //   path: '/quiz/process',
    //   name: 'process-questions',
    //   component: () => import('./views/Process.vue'),
    //   meta: { ind: 2 },
    // },
    // {
    //   path: '/quiz/technology',
    //   name: 'technology-questions',
    //   component: () => import('./views/Technology.vue'),
    //   meta: { ind: 3 },
    // },
    // {
    //   path: '/quiz/results',
    //   name: 'results',
    //   component: () => import('./views/Results.vue'),
    //   meta: { ind: 4 },
    // },
  ],
});

export default router;
